import { useRoutes } from 'react-router-dom';

import ThemeProvider from 'src/context/ThemeProvider';
import { CssBaseline } from '@mui/material';

import routes from 'src/router';
import { CycleProvider } from './context/CycleContext';

const App = () => {
  const content = useRoutes(routes);

  return (
    <ThemeProvider>
      <CycleProvider>
        <CssBaseline />
        {content}
      </CycleProvider>
    </ThemeProvider>
  );
};

export default App;
